import Banner from "components/common/Banner";
import OverlayMobile from "./OverlayMobile";
import Overlay from "./Overlay";

import envs from "config/envs";

const BannerSponsorship = () => {
  return (
    <section role="banner">
      <Banner
        width="100vw"
        height="45vw"
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner-patrocinio.webp`}
        alt={
          "Homem vestindo blazer azul claro e luvas brancas observa atentamente uma obra de arte abstrata com tons de cinza e rosa, em uma galeria com outras pinturas ao fundo."
        }
      >
        <Banner.Overlay center={false}>
          <Overlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner-patrocinio_mobile.webp`}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <OverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default BannerSponsorship;
